// removed by extract-text-webpack-plugin
module.exports = {"container":"_1h75Dbv9RZSuTUsgCnwd3W","fade-in":"_26EPS_lfbQoiExusREX1CZ","bottomContent":"_31TuqbACUtUs-VrLXk43kS","grid":"_2_OgrDol82E8BIlw-pMuDq","text":"_209RWxtvvJJT88arI3xQwe","list":"_2jlhB_zO91kgMVoJJBH32M","image":"_3GMhAvVVnYQ_FEe7y8Wa4p"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/Formula/styles.css
// module id = 328
// module chunks = 0